import React from "react";
import {
  chartTickPriceFormatWrapper,
  priceDecoratorWrapper,
} from "../../../../styles/cell-decorators";
import ChartComponent from "../../../../components/dashboard-components/chart-component/chart-component";

export default function CategoriesPricingChartComponent(props) {
  const currency = props.currency;
  return (
    <ChartComponent
      {...props}
      title={"Category Average Selling Price"}
      currentKey={"currentAvgSellingPrice"}
      previousKey={"previousAvgSellingPrice"}
      changeKey={"avgSellingPriceDiff"}
      taglineSubject={"The category average selling price"}
      legendName={"Average Selling Price"}
      yTickFormat={chartTickPriceFormatWrapper(currency)}
      valueDecorator={priceDecoratorWrapper(
        props.currency,
        "average_selling_price"
      )}
    />
  );
}
